import React, { useCallback, useEffect, useState } from 'react';
import { Form, Input, Select, Table, Button, InputNumber, Divider, DatePicker, Col, Row, Typography, message, Popover } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  BulbFilled,
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined
} from '@ant-design/icons';
import './index.css';
// import moment from 'moment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import apiClient from '../../utils/apiService';
import FieldIndexAutocomplete from '../../components/fieldindexautocomplete';


// Customer Note 示例数据
const CUSTOMER_NOTE_EXAMPLES = [
  "OB/L REQUIRED.",
  "HB/L TELEX RLSD.",
  "RELEASE ORDER REQUIRED."
];

const CREATED_WORKORDER_IDENTIFIER_KEYS = [
  'hblNo',
  'hbl_no',
  'hbl',
  'HBLNo',
  'HBL_NO',
  'pmsId',
  'pms_id',
  'pmsNo',
  'id',
  'seq',
];

const findCreatedWorkorderIdentifier = (payload, fallbackValues = {}) => {
  const visited = new Set();

  const pickFromObject = (value, allowPrimitive = false) => {
    if (!value) return null;

    if (typeof value === 'string' || typeof value === 'number') {
      const normalizedValue = String(value).trim();
      return allowPrimitive && normalizedValue ? normalizedValue : null;
    }

    if (typeof value !== 'object' || visited.has(value)) {
      return null;
    }

    visited.add(value);

    for (const key of CREATED_WORKORDER_IDENTIFIER_KEYS) {
      const candidate = value[key];
      if (candidate !== undefined && candidate !== null && String(candidate).trim()) {
        return String(candidate).trim();
      }
    }

    if (
      value.data !== undefined &&
      value.data !== null &&
      (typeof value.data === 'string' || typeof value.data === 'number') &&
      String(value.data).trim()
    ) {
      return String(value.data).trim();
    }

    for (const nestedValue of Object.values(value)) {
      if (!nestedValue || typeof nestedValue !== 'object') continue;
      const nestedIdentifier = pickFromObject(nestedValue);
      if (nestedIdentifier) return nestedIdentifier;
    }

    return null;
  };

  return (
    pickFromObject(payload) ||
    pickFromObject(fallbackValues.hbl_no, true) ||
    pickFromObject(fallbackValues.pms_id, true)
  );
};

const WorkOrderCreate = () => {

  const [messageApi, contextHolder] = message.useMessage();


  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [containerData, setContainerData] = useState([]);

  // OP list
  const [opList, setOpList] = useState([]);

  // 用户信息
  const [userInfo, setUserInfo] = useState('');
  const [autocompleteLoadingField, setAutocompleteLoadingField] = useState(null); // 自动补全加载中的字段名

  const handleAutocompleteFieldLoading = useCallback((fieldName, isLoading) => {
    setAutocompleteLoadingField(isLoading ? fieldName : null);
  }, []);

  // 组件挂载时候调接口
  useEffect(() => {
    // 获取用户info
    try {
      const userinfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userinfo) {
        setUserInfo(userinfo);
      }
    } catch (error) {
      console.log('Error getting user info:', error);
    }


    // 时间格式化
    dayjs.extend(customParseFormat);


    // 获取op list数据
    const fetchOpListData = async () => {
      try {
        const response = await apiClient.get(`/prime/auth/op-info-list`);
        console.log(response)
        // 获取 op List
        setOpList(response.data.data);
      } catch (error) {
        console.error('Error fetching Op List data:', error);
      }
    };

    fetchOpListData();

  }, [])



  const formConfig = {
    "workorderInfo": [
      { "label": "ID", "name": "pms_id", "type": "label" },
      { "label": "Agency", "name": "agency", "type": "label" },
      { "label": "Created By", "name": "created_by", "type": "label" },
      { "label": "Created Time", "name": "created_at", "type": "label" },
      { "label": "Nominated", "name": "nominated", "type": "label" },
      { "label": "Salesman", "name": "salesman", "type": "label" },
      { "label": "PIC", "name": "pic", "type": "select", "options": opList || [] },
    ],
    "entrustmentInfo": [
      { "label": "HB/L No.", "name": "hbl_no", "type": "text" },
      { "label": "MB/L No.", "name": "mbl_no", "type": "text" },
      { "label": "BKG No.", "name": "booking_no", "type": "text" },
      { "label": "AMS B/L", "name": "ams_bl", "type": "text" },
      {
        "label": "Carrier", "name": "carrier", "type": "select", "options": [
          { "value": "APL", "label": "APL" },
          { "value": "CMA-CGM", "label": "CMA-CGM" },
          { "value": "COSCO", "label": "COSCO" },
          { "value": "CULINES", "label": "CULINES" },
          { "value": "EVERGREEN", "label": "EVERGREEN" },
          { "value": "HAMBURG-SUD", "label": "HAMBURG-SUD" },
          { "value": "HAPAG-LIOYD", "label": "HAPAG-LIOYD" },
          { "value": "HMM", "label": "HMM" },
          { "value": "MAERSK", "label": "MAERSK" },
          { "value": "MATSON", "label": "MATSON" },
          { "value": "MSC", "label": "MSC" },
          { "value": "ONE", "label": "ONE" },
          { "value": "OOCL", "label": "OOCL" },
          { "value": "PIL", "label": "PIL" },
          { "value": "SM LINES", "label": "SM LINES" },
          { "value": "WAN HAI", "label": "WAN HAI" },
          { "value": "YANG MING", "label": "YANG MING" },
          { "value": "ZIM", "label": "ZIM" }
        ] || []
      },
      // { "label": "Carrier", "name": "carrier", "type": "select", "options": ["Select Carrier", "MAERSK", "COSCO", "ONE"] },
      { "label": "Vessel", "name": "vessel_name", "type": "text" },
      { "label": "VOY", "name": "voyage", "type": "text" },
      { "label": "ETD", "name": "etd", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "ETA Port", "name": "eta_port", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Place of Receipt", "name": "place_of_receipt", "type": "text" },
      { "label": "Port of Loading", "name": "port_of_loading", "type": "text" },
      { "label": "Port of Discharge", "name": "port_of_discharge", "type": "text" },
      { "label": "Place of delivery", "name": "place_of_delivery", "type": "text" }
    ],
    "shipperInfo": [
      { "label": "Company Name", "name": "shipper_company", "type": "text", "required": true },
      { "label": "Address Line 1", "name": "shipper_address1", "type": "text", "required": true },
      { "label": "Address Line 2", "name": "shipper_address2", "type": "text" },
      { "label": "Tel No.", "name": "shipper_tel", "type": "text" },
      { "label": "E-Mail", "name": "shipper_email", "type": "text" },
      { "label": "Contact Person", "name": "shipper_contact", "type": "text" }
    ],
    "consigneeInfo": [
      { "label": "Company Name", "name": "consignee_company", "type": "text", "required": true },
      { "label": "Address Line 1", "name": "consignee_address1", "type": "text", "required": true },
      { "label": "Address Line 2", "name": "consignee_address2", "type": "text" },
      { "label": "Tel No.", "name": "consignee_tel", "type": "text" },
      { "label": "E-Mail", "name": "consignee_email", "type": "text" },
      { "label": "Contact Person", "name": "consignee_contact", "type": "text" }
    ],
    "notifyPartyInfo": [
      { "label": "Company Name", "name": "notify_company", "type": "text", "required": true },
      { "label": "Address Line 1", "name": "notify_address1", "type": "text", "required": true },
      { "label": "Address Line 2", "name": "notify_address2", "type": "text" },
      { "label": "Tel No.", "name": "notify_tel", "type": "text" },
      { "label": "E-Mail", "name": "notify_email", "type": "text" },
      { "label": "Contact Person", "name": "notify_contact", "type": "text" }
    ],


    "container_cargo": [
      { "label": "Customs Entry Date", "name": "customs_entry_date", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Customs Exam Date", "name": "customs_exam_date", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Customs Release Date", "name": "customs_release_date", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "G.O. Date", "name": "go_date", "type": "date", "format": "MM/DD/YYYY" },

      { "label": "P/U # Issuing Date", "name": "pickup_issuing_date", "type": "date", "format": "MM/DD/YYYY", "labelColor": "#ff4d4f" },
    ],

    "containerInfo": [
      { title: "Container No.", dataIndex: "container_no", key: "container_no", width: 200 },
      { title: "Seal No.", dataIndex: "seal_no", key: "seal_no", width: 200 },
      { title: "TEU", dataIndex: "teu", key: "teu", width: 60 },
      { title: "No of Pkgs", dataIndex: "packages", key: "packages", width: 60 },
      { title: "Description of Goods", dataIndex: "goods_description", key: "goods_description", width: 60 },
      { title: "Gross Weight (kg)", dataIndex: "gross_weight", key: "gross_weight", width: 60 },
      { title: "Measurement (cbm)", dataIndex: "measurement", key: "measurement", width: 60 },
      { title: "Pickup Date", dataIndex: "pickup_date", key: "pickup_date", width: 200 },
      { title: "Return Date", dataIndex: "return_date", key: "return_date", width: 200 },
      { title: "Pickup Number", dataIndex: "pickup_number", key: "pickup_number", width: 160, onHeaderCell: () => ({ style: { color: '#ff4d4f' } }) },
      { title: "Last Free Day", dataIndex: "last_free_day", key: "last_free_day", width: 200 }
    ],

    "shipmentUpdateInfo": [
      { "label": "ETA Port", "name": "eta_port_update", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Dest. ETA", "name": "dest_eta", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "AN Date", "name": "an_date", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Freight Location", "name": "freight_location", "type": "text" },

      { "label": "I.T.#", "name": "it_number", "type": "text" },
      { "label": "I.T Place", "name": "it_place", "type": "text" },
      { "label": "I.T. Date", "name": "it_date", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Freight Tel", "name": "freight_tel", "type": "text" },

      { "label": "Empty Return", "name": "empty_return", "type": "text" },
      { "label": "Chassis Return", "name": "chassis_return", "type": "text" },
      { "label": "BGN Special OPTN Date", "name": "bgn_special_optn_date", "type": "text" },

      { "label": "NewShipProcess Confirmed By", "name": "confirmed_by", "type": "text" },
      { "label": "Confirmation Date", "name": "confirmation_date", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Advice Date", "name": "advice_date", "type": "date", "format": "MM/DD/YYYY" },

    ],

    "releaseInfo": [
      { "label": "HBL Receipt Date", "name": "hbl_receipt_date", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Payment Receipt Date", "name": "payment_receipt_date", "type": "date", "format": "MM/DD/YYYY" },
      { "label": "Release Date", "name": "release_date", "type": "date", "format": "MM/DD/YYYY" },
      {
        "label": "Release Time", "name": "release_flag", "type": "select",
        "options": [{ value: "AM", label: "AM" }, { value: "PM", label: "PM" }]
      }, // release -> release_flag
      {
        "label": "Cashier", "name": "cashier_type", "type": "select",
        "options": [
          { value: 'CS0001', label: 'CS0001' },
          { value: 'CS0002', label: 'CS0002' },
          { value: 'CS0003', label: 'CS0003' },
          { value: 'CS0004', label: 'CS0004' },
          { value: 'CS0005', label: 'CS0005' },
          { value: 'CS0006', label: 'CS0006' },
          { value: 'CS0007', label: 'CS0007' },
          { value: 'CS0008', label: 'CS0008' },
          { value: 'CS0009', label: 'CS0009' }
        ]
      }
    ],


    "costInfo": {
      "collectForAgent": [
        { "label": "HB/L Freight PPD", "name": "hbl_freight_ppd", "type": "currency" },
        { "label": "O/F CC", "name": "of_cc", "type": "currency" },
        { "label": "DDC Devanning", "name": "ddc_devanning", "type": "currency" },
        { "label": "BAF CC", "name": "baf_cc", "type": "currency" },
        { "label": "ARB CFS", "name": "arb_cfs", "type": "currency" },
        { "label": "PSC Pierpass", "name": "psc_pierpass", "type": "currency" },
        { "label": "ORC Port Security", "name": "orc_port_security", "type": "currency" },
        { "label": "GRI CTF", "name": "gri_ctf", "type": "currency" },
        { "label": "PSS Exam Fee", "name": "pss_exam_fee", "type": "currency" },
        { "label": "ACC THC", "name": "acc_thc", "type": "currency" },
        { "label": "I.T Fee", "name": "it_fee", "type": "currency" },
        { "label": "DOC CC", "name": "doc_cc", "type": "currency" },
        { "label": "AMS ISF FEE", "name": "ams_isf_fee", "type": "currency" },
        { "label": "Overdue Amount", "name": "overdue_amount", "type": "currency" },
        { "label": "Other CC", "name": "other_cc", "type": "currency" }, // other_cc
        { "label": "Total CC", "name": "total_cc", "type": "currency" },
      ],
      "payToPrime": [
        { "label": "MBL CC", "name": "mbl_cc", "type": "currency" },
        { "label": "Handling Fee", "name": "handling_fee", "type": "currency" },
        { "label": "Trucking Fee", "name": "trucking_fee", "type": "currency" },
        { "label": "Profit Share", "name": "profit_share", "type": "currency" },
        { "label": "Balance To Origin", "name": "balance_to_origin", "type": "currency" },
      ],
      "balance_change": [
        { "label": "change1", "name": "balance_change1", "type": "text" },
        { "label": "amount1", "name": "balance_change_amount1", "type": "currency" },
        { "label": "change2", "name": "balance_change2", "type": "text" },
        { "label": "amount2", "name": "balance_change_amount2", "type": "currency" },
        { "label": "change3", "name": "balance_change3", "type": "text" },
        { "label": "amount3", "name": "balance_change_amount3", "type": "currency" },
      ],
      "costbottom": [
        // final_balance
        { "label": "Final Balance", "name": "final_balance", "type": "currency" },
      ],
      "note": [
        { "label": "Origin Note", "name": "origin_note", "type": "textarea" },
        { "label": "​Hold Note", "name": "hold_note", "type": "textarea" },
      ]
    },
    "otherInfo": [
      { "label": "Prime Note", "name": "prime_note", "type": "textarea" },
      { "label": "Customer Note", "name": "customer_note", "type": "textarea" },
      { "label": "AN Remark", "name": "an_remark", "type": "text" },
      { "label": "PU Remark", "name": "pu_remark", "type": "text" },
    ]
  }


  // 自定义表单区块组件
  const FormSection = ({ title, children, columns = 3, className = '' }) => (
    <div className="form-section">
      {title != 'Container Cargo' && <div className="section-header">
        <div className="header-line" />
        <h3>{title}</h3>
      </div>}
      <div className={className === 'workorderinfo' ? `${className}` : `form-grid columns-${columns}`}>
        {children}
      </div>
    </div>
  );


  // 自定义表单字段组件
  const AUTOCOMPLETE_FIELD_NAMES = ['port_of_loading', 'port_of_discharge', 'place_of_delivery', 'freight_location', 'freight_tel', 'consignee_email', 'notify_email'];

  const FormField = ({ field = {} }) => {
    const renderInput = () => {
      switch (field.type) {
        case 'label':
          return (
            <Typography.Text className='typographytext'>
              {form.getFieldValue(field.name) || 'N/A'} {/* 动态获取值 */}
            </Typography.Text>
          );
        case 'select':
          return (
            <Select
              value={form.getFieldValue(field.name)}
              disabled={field.name === 'release_flag' && userInfo.canEditFinance === 0}
              showSearch
              allowClear
              style={{ width: '100%' }}
            >
              {field.options?.map((opt, index) => (
                <Select.Option
                  key={index}
                  value={typeof opt === 'object' && opt !== null && !Array.isArray(opt) && Object.keys(opt).length === 0 ? '' : (Object(opt) ? opt.value : opt)}
                >
                  {typeof opt === 'object' && opt !== null && !Array.isArray(opt) && Object.keys(opt).length === 0 ? '' : (Object(opt) ? opt.label : opt)}
                </Select.Option>
              ))}
            </Select>
          );
        case 'date':
          return (
            <DatePicker
              style={{ width: '100%' }}
              format={field.format || 'MM/DD/YYYY'}
              disabled={['payment_receipt_date', 'hbl_receipt_date', 'release_date'].includes(field.name) && userInfo.canEditFinance === 0}
            />
          )
        case 'textarea':
          return (
            <Input.TextArea
              rows={4}
            // disabled={field.name === 'hold_note' && userInfo.canEditFinance === 0}
            />);
        case 'currency':
          return (
            <InputNumber
              style={{ width: '100%' }}
              step="0.01"
              onChange={handleFeeChange}
              disabled={field.name == 'total_cc' || field.name == 'balance_to_origin' ? true : false}
              precision={2}
              controls={false}
              prefix="$"
            />);
        default:
          return (
            <Input />
          );
      }
    };



    return (
      <div
        className={`workorderinfo-item ${field.type === 'label' ? 'workorderinfo-label-item' : ''} ${field.type === 'select' && field.name === 'pic' ? 'workorderinfo-select-item' : ''}`}
      >
        <Form.Item
          label={field.labelColor ? <span style={{ color: field.labelColor }}>{field.label || 'Unknown Label'}</span> : (field.label || 'Unknown Label')}
          name={field.name}
        >
          {renderInput()}
        </Form.Item>

        {field.type !== 'label' &&
          <>
            {field.name === 'customer_note' && (
              <Popover
                content={
                  <div style={{ maxWidth: 300 }}>
                    {CUSTOMER_NOTE_EXAMPLES.map((example, index) => (
                      <div
                        key={index}
                        style={{
                          padding: '8px 12px',
                          cursor: 'pointer',
                          borderRadius: '4px',
                          marginBottom: '4px',
                          transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        onClick={() => {
                          const current = form.getFieldValue(field.name) || '';
                          const newValue = current ? `${current} ${example}` : example;
                          form.setFieldsValue({ [field.name]: newValue });
                        }}
                      >
                        {example}
                      </div>
                    ))}
                  </div>
                }
                title="Example"
                trigger="click"
                placement="bottomLeft"
              >
                <div
                  className='workorderinfo-item-icon'
                  style={{ marginRight: '12px' }}
                >
                  <BulbFilled style={{ color: '#ffb300' }} />
                </div>
              </Popover>
            )}

            {AUTOCOMPLETE_FIELD_NAMES.includes(field.name) && autocompleteLoadingField === field.name && (
              <div className='workorderinfo-item-icon' style={{ marginRight: 2 }}>
                <LoadingOutlined style={{ color: '#1f63fb' }} spin />
              </div>
            )}
          </>
        }

      </div>
    );
  };


  // 处理container table
  dayjs.extend(customParseFormat);


  // 处理容器数据变化
  const handleContainerChange = (index, field, value) => {
    const newContainerData = [...containerData];
    newContainerData[index][field] = value;
    setContainerData(newContainerData);
  };

  // 添加新容器行
  const handleAddContainer = () => {
    const newContainer = {
      id: Date.now() + (Math.random() * 10000), // 临时ID
      container_no: '',
      seal_no: '',
      teu: '',
      packages: '',
      goods_description: '',
      gross_weight: '',
      measurement: '',
      pickup_date: '',
      return_date: '',
      pickup_number: '',
      last_free_day: ''
    };
    setContainerData([...containerData, newContainer]);
  };

  // 删除容器行
  const handleDeleteContainer = (id) => {
    const newContainerData = containerData.filter(item => item.id !== id);
    setContainerData(newContainerData);
  };

  // 计算容器数据的统计总和
  const calculateContainerTotals = () => {
    return containerData.reduce((totals, item) => {
      return {
        teu: totals.teu + (parseFloat(item.teu) || 0),
        packages: totals.packages + (parseFloat(item.packages) || 0),
        gross_weight: totals.gross_weight + (parseFloat(item.gross_weight) || 0),
        measurement: totals.measurement + (parseFloat(item.measurement) || 0)
      };
    }, { teu: 0, packages: 0, gross_weight: 0, measurement: 0 });
  };


  // 统计费用
  const sumValues = (...nums) =>
    nums.reduce((acc, val) => acc + Number(val || 0), 0);

  const subtractValues = (start, ...rest) =>
    rest.reduce((acc, val) => acc - Number(val || 0), Number(start || 0));

  const handlePoint = (value, digits = 2) => {
    const num = Number(value || 0);
    if (Number.isNaN(num)) return 0;
    return Number(num.toFixed(digits));
  };

  const handleFeeChange = () => {
    const values = form.getFieldsValue();

    const totalCC = sumValues(
      // values.hbl_freight_ppd,
      values.of_cc,
      values.ddc_devanning,
      values.baf_cc,
      values.arb_cfs,
      values.psc_pierpass,
      values.orc_port_security,
      values.gri_ctf,
      values.pss_exam_fee,
      values.acc_thc,
      values.ams_isf_fee, // 由ams_bl 改的
      values.it_fee,
      values.doc_cc,
      values.other_cc
    );

    const balanceToOrigin = subtractValues(
      totalCC,
      values.mbl_cc,
      values.trucking_fee,
      values.profit_share,
      values.handling_fee
    );



    // 计算 final_balance = 所有 balance_change_amount 的和 + balance_to_origin
    const finalBalance = sumValues(
      values.balance_change_amount1,
      values.balance_change_amount2,
      values.balance_change_amount3,
      balanceToOrigin
    );

    form.setFieldsValue({
      total_cc: handlePoint(totalCC),
      balance_to_origin: handlePoint(balanceToOrigin),
      final_balance: handlePoint(finalBalance),
    });

  };







  // 保存工单数据
  const [createLoading, setcreateLoading] = useState(false);
  const handleCreate = async () => {
    try {
      setcreateLoading(true);
      // 获取表单数据
      const formData = await form.validateFields();

      // 格式化日期字段为 YYYY-MM-DD
      const formattedData = { ...formData };
      Object.keys(formattedData).forEach(key => {
        // 检查是否为日期字段（你需要根据实际的formConfig结构来调整这部分）
        const isDateField = Object.values(formConfig).flat().some(field =>
          field && field.name === key && field.type === 'date'
        );

        if (isDateField && formattedData[key]) {
          // 如果是dayjs对象，格式化为YYYY-MM-DD
          if (dayjs.isDayjs(formattedData[key])) {
            formattedData[key] = formattedData[key].format('YYYY-MM-DD');
          }
          // 如果是ISO格式的日期字符串，转换为YYYY-MM-DD
          else if (typeof formattedData[key] === 'string' && formattedData[key].endsWith('Z') && formattedData[key].includes('T')) {
            try {
              const date = dayjs(formattedData[key]);
              if (date.isValid()) {
                formattedData[key] = date.format('YYYY-MM-DD');
              }
            } catch (e) {
              console.warn('Date formatting error:', e);
            }
          }
        }
      });

      ['hbl_no', 'mbl_no', 'booking_no', 'ams_bl'].forEach((fieldName) => {
        if (typeof formattedData[fieldName] === 'string') {
          formattedData[fieldName] = formattedData[fieldName].trim();
        }
      });


      const resContainerData = containerData.map(container => {
        const formattedContainer = { ...container };
        // 确保日期字段格式为 YYYY-MM-DD
        if (formattedContainer.pickup_date) {
          if (dayjs.isDayjs(formattedContainer.pickup_date)) {
            formattedContainer.pickup_date = formattedContainer.pickup_date.format('YYYY-MM-DD');
          } else if (typeof formattedContainer.pickup_date === 'string' && formattedContainer.pickup_date.includes('/')) {
            // 如果是 MM/DD/YYYY 格式，转换为 YYYY-MM-DD
            const date = dayjs(formattedContainer.pickup_date, 'MM/DD/YYYY');
            if (date.isValid()) {
              formattedContainer.pickup_date = date.format('YYYY-MM-DD');
            }
          }
        }

        if (formattedContainer.return_date) {
          if (dayjs.isDayjs(formattedContainer.return_date)) {
            formattedContainer.return_date = formattedContainer.return_date.format('YYYY-MM-DD');
          } else if (typeof formattedContainer.return_date === 'string' && formattedContainer.return_date.includes('/')) {
            // 如果是 MM/DD/YYYY 格式，转换为 YYYY-MM-DD
            const date = dayjs(formattedContainer.return_date, 'MM/DD/YYYY');
            if (date.isValid()) {
              formattedContainer.return_date = date.format('YYYY-MM-DD');
            }
          }
        }

        if (formattedContainer.last_free_day) {
          if (dayjs.isDayjs(formattedContainer.last_free_day)) {
            formattedContainer.last_free_day = formattedContainer.last_free_day.format('YYYY-MM-DD');
          } else if (typeof formattedContainer.last_free_day === 'string' && formattedContainer.last_free_day.includes('/')) {
            // 如果是 MM/DD/YYYY 格式，转换为 YYYY-MM-DD
            const date = dayjs(formattedContainer.last_free_day, 'MM/DD/YYYY');
            if (date.isValid()) {
              formattedContainer.last_free_day = date.format('YYYY-MM-DD');
            }
          }
        }

        return formattedContainer;
      })

      // 准备请求数据
      const requestData = {
        ...formattedData,
        containers: resContainerData,
      };

      console.log('requestData', requestData)

      // 发送更新请求
      const response = await apiClient.post('/shipping-order/create', requestData);

      if (response.data.code === 200) {
        messageApi.success('Create Success');
        const createdIdentifier = findCreatedWorkorderIdentifier(response.data, requestData);
        if (createdIdentifier) {
          navigate(`/workorderdetail/${encodeURIComponent(createdIdentifier)}`, { replace: true });
        } else {
          messageApi.warning('Created successfully, but no workorder identifier was returned.');
        }
      } else {
        messageApi.error(response.data.message || 'Create Failure');
      }
    } catch (error) {
      console.error('Create Failure', error);
      messageApi.error('Create Failure: ' + (error.response?.data?.message || error.message));
    } finally {
      setcreateLoading(false);
    }
  };



  // 整个组件的 Dom
  return (
    <div className='workordercreate'>
      {contextHolder}

      <div className="workordercreate-fixedtoolbtn">
        <div className="workordercreate-toolbtn-left">
          <Button
            type='link'
            size='small'
            onClick={() => navigate(-1)}
            style={{
              fontSize: 12
            }}
          >
            Return to Workorder
          </Button>

          {/* 创建 */}
          <Button
            type='primary'
            size="middle"
            style={{ marginRight: 8 }}
            onClick={handleCreate}
            loading={createLoading}
          >
            Create
          </Button>
        </div>
      </div>


      {/* <div className="workordercreate-toolbtn">
        <div className="workordercreate-toolbtn-left">
          <Button
            type='link'
            size='small'
            onClick={() => navigate(-1)}
            style={{
              fontSize: 12
            }}
          >
            Return to Workorder
          </Button>

          <Button
            type='primary'
            size="small"
            style={{ marginRight: 8 }}
            onClick={handleCreate}
            loading={createLoading}
          >
            Create
          </Button>
        </div>

      </div> */}


      {/* <div className="workordercreate-header">
        <h2>PRIME SHIPPING INTERNATIONAL, INC.</h2>
      </div> */}


      {/* 表单 */}
      <div className="workordercreate-content">
        <div className="workordercreate-left">
          <Form
            form={form}
            layout="horizontal"
          >
            {/* 顶部关键字段行: HBL / MBL / AMS B\/L / PIC */}
            <div className="detail-top-keyfields">
              {[
                formConfig.entrustmentInfo.find(f => f.name === 'hbl_no'),
                formConfig.entrustmentInfo.find(f => f.name === 'mbl_no'),
                formConfig.entrustmentInfo.find(f => f.name === 'ams_bl'),
                formConfig.workorderInfo.find(f => f.name === 'pic'),
              ].map((field, index) => field && (
                <div key={index} className="detail-top-keyfield">
                  <FormField field={field} />
                </div>
              ))}
            </div>

            {/* 两列布局: Shipper + Transport Information */}
            <div className="detail-two-col-layout">
              <FormSection title="Shipper / Exporter" columns={1}>
                {formConfig.shipperInfo.map((field, index) => (
                  field && field.label ? <FormField key={index} field={field} /> : null
                ))}
              </FormSection>
              <FormSection title="Transport Information" columns={2}>
                {formConfig.entrustmentInfo
                  .filter(f => !['hbl_no', 'mbl_no', 'ams_bl'].includes(f.name))
                  .map((field, index) => (
                    field && field.label ? <FormField key={index} field={field} /> : null
                  ))}
              </FormSection>
            </div>

            {/* 两列布局: Consignee + Notify Party */}
            <div className="detail-two-col-layout">
              <FormSection title="Consignee" columns={1}>
                {formConfig.consigneeInfo.map((field, index) => (
                  field && field.label ? <FormField key={index} field={field} /> : null
                ))}
              </FormSection>
              <FormSection title="Notify Party" columns={1}>
                {formConfig.notifyPartyInfo.map((field, index) => (
                  field && field.label ? <FormField key={index} field={field} /> : null
                ))}
              </FormSection>
            </div>

            {/* Container Cargo Information */}
            <div className="form-section">
              <div className="section-header">
                <div className="header-line" />
                <h3>Container Cargo Information</h3>
              </div>

              <FormSection title="Container Cargo" columns={4}>
                {formConfig.container_cargo.map((field, index) => (
                  field && field.label ? <FormField key={index} field={field} /> : null
                ))}
              </FormSection>

              <Table
                columns={[
                  ...formConfig.containerInfo,
                  ...[{
                    title: 'Action',
                    key: 'action',
                    render: (_, record) => (
                      record.key !== 'total' && <Button
                        type="link"
                        danger
                        onClick={() => handleDeleteContainer(record.id)}
                        icon={<DeleteOutlined />}
                      >

                      </Button>
                    ),
                  }]
                ]}
                dataSource={[
                  ...containerData.map((item, index) => ({
                    ...item,
                    key: item.id || index,
                    container_no:
                      <Input
                        value={item.container_no}
                        onChange={e => handleContainerChange(index, 'container_no', e.target.value)}
                      />,
                    seal_no: <Input
                      value={item.seal_no}
                      onChange={e => handleContainerChange(index, 'seal_no', e.target.value)}
                    />,
                    teu: <InputNumber
                      value={item.teu}
                      onChange={value => handleContainerChange(index, 'teu', value)}
                      style={{ width: 40 }}
                    // step="0.01"
                    />,
                    packages: <InputNumber
                      value={item.packages}
                      onChange={value => handleContainerChange(index, 'packages', value)}
                    // step="0.01"
                    />,
                    goods_description: <Input
                      value={item.goods_description}
                      onChange={e => handleContainerChange(index, 'goods_description', e.target.value)}
                    />,
                    gross_weight: <InputNumber
                      value={item.gross_weight}
                      onChange={value => handleContainerChange(index, 'gross_weight', value)}
                      step="0.01"
                    />,
                    measurement: <InputNumber
                      value={item.measurement}
                      onChange={value => handleContainerChange(index, 'measurement', value)}
                    // step="0.01"
                    />,
                    pickup_date: <DatePicker
                      value={item.pickup_date ? dayjs(item.pickup_date) : null}
                      onChange={(_, dateString) => handleContainerChange(index, 'pickup_date', dateString)}
                    />,
                    return_date: <DatePicker
                      value={item.return_date ? dayjs(item.return_date) : null}
                      onChange={(_, dateString) => handleContainerChange(index, 'return_date', dateString)}
                    />,
                    pickup_number: <Input
                      value={item.pickup_number}
                      onChange={e => handleContainerChange(index, 'pickup_number', e.target.value)}
                    />,
                    last_free_day: <DatePicker
                      value={item.last_free_day ? dayjs(item.last_free_day) : null}
                      onChange={(_, dateString) => handleContainerChange(index, 'last_free_day', dateString)}
                    />,
                  })),
                  {
                    key: 'total',
                    container_no: 'Total',
                    seal_no: '',
                    teu: calculateContainerTotals().teu,
                    packages: calculateContainerTotals().packages,
                    goods_description: '',
                    gross_weight: calculateContainerTotals().gross_weight,
                    measurement: calculateContainerTotals().measurement,
                    pickup_date: '',
                    return_date: '',
                    pickup_number: '',
                    last_free_day: '',
                    action: '',
                  }
                ]}
                pagination={false}
                rowKey='key'
                scroll={{ x: 'max-content' }}
                onRow={(record) => {
                  if (record.key === 'total') {
                    return {
                      style: { background: '#f5f5f5', fontWeight: 'bold' }
                    };
                  }
                  return {};
                }}
              />

              {
                <div className="containerinfo-bottom" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    type="default"
                    onClick={handleAddContainer}
                    icon={<PlusOutlined />}
                    style={{ marginTop: 16 }}
                  />
                </div>
              }
            </div>

            {/* Shipment Update Information */}
            <FormSection title="Shipment Update Information" columns={4}>
              {formConfig.shipmentUpdateInfo.map((field, index) => (
                field && field.label ? <FormField key={index} field={field} /> : null
              ))}
            </FormSection>


            <FormSection title="Release Information" columns={4}>
              {formConfig.releaseInfo.map((field, index) => (
                field && field.label ? <FormField key={index} field={field} /> : null
              ))}
            </FormSection>



            {/* Cost Information  */}
            <FormSection title="Cost Information" columns={1}>
              {/* 第一部分：COLLECT FOR AGENT */}
              <Row gutter={16} style={{ height: '100%' }}>
                <Col span={17}>
                  <h3>Collect for Agent</h3>
                  <Row gutter={16}>
                    {formConfig.costInfo.collectForAgent.map((field) => (
                      <Col span={6} key={field.name}>
                        <Form.Item
                          label={field.label}
                          name={field.name}
                          rules={[{ required: field.required }]}
                        >
                          <InputNumber
                            style={{ width: '100%' }}
                            // formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            step="0.01"
                            onChange={handleFeeChange}
                            precision={2}
                            controls={false}
                            prefix="$"
                          />
                        </Form.Item>
                      </Col>
                    ))}
                  </Row>
                </Col>

                {/* 第二部分：PAY TO PRIME */}
                <Divider type="vertical" style={{ height: '100%' }} />

                <Col span={6}>
                  <h3>Pay to Prime</h3>
                  {formConfig.costInfo.payToPrime.map((field) => (
                    <Form.Item label={field.label} name={field.name} key={field.name}>
                      <InputNumber
                        style={{ width: '100%' }}
                        step="0.01"
                        onChange={handleFeeChange}
                        controls={false}
                        prefix={"$"}
                      />
                    </Form.Item>
                  ))}
                </Col>
              </Row>



              {/* 第三部分：Cost Bottom */}
              <Row gutter={24} style={{ marginTop: 12 }}>

                {/* note */}
                <Col span={12}>
                  {formConfig.costInfo.note.map((field, index) => (
                    field && field.label ? (
                      <Col span={24} key={index}>
                        <Form.Item
                          label={field.label}
                          name={field.name}
                          key={index}
                        >
                          <Input.TextArea
                            rows={4}
                          />
                        </Form.Item>
                      </Col>
                    ) : null
                  ))}
                </Col>



                {/* balance change and costbottom */}
                <Col span={12}>
                  <div className='balance-change'>
                    <div className='balance-change-label' >Balance Change</div>
                    <div>
                      {formConfig.costInfo.balance_change.map((field, index) => {
                        if (index % 2 === 0) {
                          const nextField = formConfig.costInfo.balance_change[index + 1];
                          return (
                            <Col span={24} key={index}>
                              <Row gutter={16}>
                                <Col span={12}>
                                  <Form.Item
                                    label={field.label}
                                    name={field.name}
                                    style={{ marginBottom: 0 }}
                                  >
                                    {field.type === 'currency' ? (
                                      <InputNumber
                                        style={{ width: '100%' }}
                                        step="0.01"
                                        onChange={handleFeeChange}
                                        precision={2}
                                        controls={false}
                                        prefix="$"
                                      />
                                    ) : (
                                      <Input
                                      />
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item
                                    // label={nextField?.label}
                                    name={nextField?.name}
                                    style={{ marginBottom: 0 }}
                                  >
                                    {nextField?.type === 'currency' ? (
                                      <InputNumber
                                        style={{ width: '100%' }}
                                        step="0.01"
                                        onChange={handleFeeChange}
                                        precision={2}
                                        controls={false}
                                        prefix="$"
                                      />
                                    ) : (
                                      <Input
                                      />
                                    )}
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                          );
                        }
                        return null;
                      })}
                    </div>
                  </div>



                  <Row gutter={24}  style={{margin: 12, display:'flex', justifyContent: 'flex-end' }}>
                    {formConfig.costInfo.costbottom.map((field, index) => (
                      field && field.label ? (
                        <Col span={12} key={index}>
                          <Form.Item
                            label={field.label}
                            name={field.name}
                            key={index}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              step="0.01"
                              disabled={true}
                              precision={2}
                              controls={false}
                              prefix="$"
                            />
                          </Form.Item>
                        </Col>
                      ) : null
                    ))}
                  </Row>

                </Col>






              </Row>



            </FormSection>






            {/* Others */}
            <div className="form-section">
              <div className="section-header">
                <div className="header-line" />
                <h3>Others</h3>
              </div>
              <div className="notes-section">
                {formConfig.otherInfo.map((field, index) => (
                  field && field.label ? <FormField key={index} field={field} /> : null
                ))}
              </div>
            </div>

            {/* 字段索引模糊查询自动补全 */}
            <FieldIndexAutocomplete
              form={form}
              fieldNames={['port_of_loading', 'port_of_discharge', 'place_of_delivery', 'freight_location', 'freight_tel', 'consignee_email', 'notify_email']}
              userInfo={userInfo}
              onFieldLoadingChange={handleAutocompleteFieldLoading}
            />
          </Form>
        </div>


      </div>
    </div>
  );
};

export default WorkOrderCreate;
